import React, { useState } from "react";
import IncentiveCalculator from './IncentiveCalculator.js'

export default function InputGroup({
    name,
    label,
    description,
    id,
    defaultValue,
    value,
    onChange,
    type='text',
    evMsrpCost
}) {
    const [modalOpen, setModalOpen] = useState(false);
    
    return (
        <div className="mb-6">
            <div className="flex w-full">
                {/* Left Half - Label and Description */}
                <div className="w-1/2 pr-6">
                    <label className="block text-sm font-medium text-gray-700 font-nunito mb-2">
                        {label}
                    </label>
                    
                    {description && (
                        <div 
                            className="text-xs text-gray-600 leading-relaxed break-words font-nunito mb-2"
                            dangerouslySetInnerHTML={{ __html: description }}
                        />
                    )}
                    
                    {/* Incentive Calculator Button */}
                    {description === "Incentives, rebates, or discounts (example: <a href=\"https://californiahvip.org/\" target=\"_blank\">California HVIP</a>)" && (
                        <div className="mt-4">
                            <button 
                                className="w-44 h-10 bg-gradient-to-r from-primary-light to-primary text-white font-nunito rounded-full border-0 cursor-pointer hover:shadow-lg transition-shadow duration-200 text-sm font-medium"
                                onClick={() => {
                                    setModalOpen(true);
                                }}
                            >
                                Incentive Calculator
                            </button>
                            {modalOpen && (
                                <IncentiveCalculator 
                                    setOpenModal={setModalOpen}
                                    evMsrpCost={evMsrpCost}
                                    id={id}
                                    onChange={onChange}
                                    type='text'
                                />
                            )}
                        </div>
                    )}
                </div>
                
                {/* Right Half - Input */}
                <div className="w-1/2 flex items-start">
                    <input
                        type={type}
                        id={id}
                        className="w-2/5 px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 font-nunito text-right"
                        defaultValue={defaultValue.toString()}
                        value={value}
                        onChange={(e) => onChange(e.target.value)}
                    />
                </div>
            </div>
            
            {/* Special spacing for dieselIncentives */}
            {name === "dieselIncentives" && (
                <div className="mb-12"></div>
            )}
        </div>
    );
}